import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { DataGrid } from '@mui/x-data-grid';
import { DETAILED_DATA_GRID_CLASS_NAME } from '../../../theme/constants/data-grid';
import DataGridRenderHeader from '../../../components/dataGrids/DataGridRenderHeader';

const InvoiceSummaryHeaderTable = ({ invoice, columns }) => {
  const gridColumns = useMemo(
    () => columns.map((column) => ({
      field: column.key,
      headerName: column.header,
      flex: 1,
      minWidth: 120,
      sortable: false,
      renderHeader: DataGridRenderHeader,
      renderCell: ({ row }) => column.render(row.invoice),
    })),
    [columns],
  );
  const rows = invoice ? [{ id: invoice.id, invoice }] : [];

  return (
    <DataGrid
      className={DETAILED_DATA_GRID_CLASS_NAME}
      columns={gridColumns}
      rows={rows}
      autoHeight
      hideFooter
      disableColumnMenu
      disableSelectionOnClick
      rowHeight={60}
    />
  );
};

InvoiceSummaryHeaderTable.propTypes = {
  invoice: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      header: PropTypes.string.isRequired,
      render: PropTypes.func.isRequired,
    }),
  ).isRequired,
};

InvoiceSummaryHeaderTable.defaultProps = {
  invoice: null,
};

export default InvoiceSummaryHeaderTable;
